import { useNavigate } from "react-router-dom";
import { useAuth } from "../AuthnContext";
import NavbarUnauth from "./login/NavbarUnauth";
import NavbarPacjent from "./pacjent/NavbarPacjent";
import NavbarPracownik from "./pracownik/NavbarPracownik";
import NavbarAdmin from "./admin/AdminNavbar";

function Navbar() {

  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const handleLogout = () => {
    logout();
    navigate("/");
  };

  if (user && user.role == "Patient") return <NavbarPacjent logout={handleLogout} />;
  if (user && user.role == "Employee") return <NavbarPracownik logout={handleLogout} />;
  if (user && user.role == "Admin") return <NavbarAdmin logout={handleLogout} />;

  
  return <NavbarUnauth />

}

export default Navbar;